import { BellRing, KeyRound, ShieldCheck, Sparkles } from "lucide-react";

const eventConfig = {
  CLOSER_SEND: {
    icon: Sparkles,
    badge: "border-[#D4AF37]/25 bg-[#fff4db] text-[#8b6d16]",
  },
  WEBHOOK_SIGNAL: {
    icon: BellRing,
    badge: "border-emerald-200 bg-emerald-50 text-emerald-700",
  },
  AUTH_CHANGE: {
    icon: ShieldCheck,
    badge: "border-sky-200 bg-sky-50 text-sky-700",
  },
  PRODUCTION_TOGGLE: {
    icon: KeyRound,
    badge: "border-amber-200 bg-amber-50 text-amber-700",
  },
  PRODUCTION_CUTOVER: {
    icon: KeyRound,
    badge: "border-emerald-200 bg-emerald-50 text-emerald-700",
  },
  PROJECT_LAUNCH: {
    icon: Sparkles,
    badge: "border-emerald-200 bg-emerald-50 text-emerald-700",
  },
};

const sanitizeProviderNames = (value = "") => value
  .replaceAll("Twilio", "Messaging")
  .replaceAll("twilio", "messaging")
  .replaceAll("Gemini", "AI")
  .replaceAll("gemini", "ai");

export const MissionControlActivityLog = ({ logs = [] }) => {
  return (
    <section className="rounded-[32px] border border-[#001935]/10 bg-white/95 p-6 shadow-[0_20px_60px_rgba(0,25,53,0.08)] md:p-8" data-testid="mission-control-activity-log">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#8b6d16]">Mission Control Activity Log</p>
          <h3 className="mt-2 text-2xl font-semibold text-[#001935]">Live launch actions with SGT timestamps</h3>
          <p className="mt-3 max-w-3xl text-sm leading-7 text-[#42566f]">
            This feed records Closer sends, webhook handshakes, auth changes, and production-mode toggles using Singapore time so launch operations stay audit-ready.
          </p>
        </div>
        <div className="rounded-full border border-[#001935]/10 bg-[#f8f5ef] px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#42566f]" data-testid="mission-control-activity-log-count">
          {logs.length} recent events
        </div>
      </div>

      <div className="mt-6 grid gap-4">
        {logs.map((entry) => {
          const config = eventConfig[entry.event_type] || eventConfig.AUTH_CHANGE;
          const Icon = config.icon;
          return (
            <div className="rounded-[24px] border border-[#001935]/10 bg-[#fffaf1] p-5" data-testid={`mission-control-activity-log-row-${entry.id}`} key={entry.id}>
              <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                <div className="flex min-w-0 flex-1 items-start gap-4">
                  <div className="rounded-full bg-white p-3 text-[#8b6d16] shadow-[0_10px_30px_rgba(0,25,53,0.08)]">
                    <Icon className="h-4 w-4" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`rounded-full border px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] ${config.badge}`} data-testid={`mission-control-activity-type-${entry.id}`}>
                        {entry.event_type}
                      </span>
                      {entry.subject_name ? <span className="rounded-full border border-[#001935]/10 bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-[#42566f]" data-testid={`mission-control-activity-subject-${entry.id}`}>{entry.subject_name}</span> : null}
                    </div>
                    <p className="mt-3 text-lg font-semibold text-[#001935]" data-testid={`mission-control-activity-title-${entry.id}`}>{sanitizeProviderNames(entry.title || "")}</p>
                    <p className="mt-2 text-sm leading-7 text-[#42566f]" data-testid={`mission-control-activity-detail-${entry.id}`}>{sanitizeProviderNames(entry.detail || "")}</p>
                  </div>
                </div>
                <div className="rounded-[20px] border border-[#001935]/10 bg-white px-4 py-3 text-right text-xs font-bold uppercase tracking-[0.16em] text-[#42566f]" data-testid={`mission-control-activity-time-${entry.id}`}>
                  {entry.occurred_at_sgt_label}
                </div>
              </div>
            </div>
          );
        })}

        {!logs.length ? (
          <div className="rounded-[24px] border border-dashed border-[#001935]/15 bg-[#fffaf1] px-4 py-6 text-sm text-[#6b6252]" data-testid="mission-control-activity-empty-state">
            No Mission Control actions have been recorded yet.
          </div>
        ) : null}
      </div>
    </section>
  );
};